import { createContext, useContext, useState } from 'react';

const PrintContext = createContext(null);

export const PrintContextProvider = ({ children }) => {
  const [printImagesStatusArr, setPrintImagesStatusArr] = useState([]);
  return (
    <PrintContext.Provider
      value={{
        printImagesStatusArr,
        setPrintImagesStatusArr,
      }}>
      {children}
    </PrintContext.Provider>
  );
};

export const usePrint = () => useContext(PrintContext);
